import {BaseMuWidget} from "../BaseMuWidget";
import {DmsCL} from "../generated/DmsCL";
import {Arrays} from "../Utils";

export class BaseCompanyForm extends BaseMuWidget {
	beforeIndex() {
		this.muAppendContent(`
			<div class="form-group row">
				<label class="col-sm-3">
					IČ / DIČ
				</label>
				<div class="col-sm-5">
					<div class="input-group">
					<input type="text" mu="ic#ic" class="form-control">
						<span class="input-group-btn">
							<span class="btn btn-primary" mu-id="bAres">Načíst dle IČ</span>
						</span>
					</div>
				</div>
				<div class="col-sm-4">
					<input type="text" mu-bind="dic" class="form-control">
				</div>
			</div>
			<div class="form-group row">
				<label class="col-sm-3">
					Název
				</label>
				<div class="col-sm-9">
					<input type="text" mu-bind="name" class="form-control">
				</div>
			</div>
			<div class="form-group row">
				<label class="col-sm-3">
					Ulice / čp / čo
				</label>
				<div class="col-sm-5">
					<input type="text" mu-bind="address_street" class="form-control">
				</div>
				<div class="col-sm-2">
					<input type="text" mu-bind="address_nd" class="form-control">
				</div>
				<div class="col-sm-2">
					<input type="text" mu-bind="address_no" class="form-control">
				</div>
			</div>
			<div class="form-group row">
				<label class="col-sm-3">
					Město / PSČ
				</label>
				<div class="col-sm-5">
					<input type="text" mu-bind="address_city" class="form-control">
				</div>
				<div class="col-sm-4">
					<input type="text" mu-bind="address_zip" class="form-control">
				</div>
			</div>
			<div class="form-group row">
				<label class="col-sm-3">
					Stát
				</label>
				<div class="col-sm-9">
					<input type="text" mu-bind="address_country" class="form-control">
				</div>
			</div>`)
	}

	async bAres_click() {
		const aresData = await (new DmsCL()).loadFromAres(this.ui.ic.value);
		this.muBindData({
			...aresData,
			address_street: aresData.address.street,
			address_nd: aresData.address.numD,
			address_no: aresData.address.numO,
			address_city: Arrays.unique([aresData.address.cityCityPart, aresData.address.cityPart, aresData.address.city])
				.map(s => s.trim())
				.filter(s => s !== '')
				.join(', '),
			address_zip: aresData.address.zip,
			address_country: aresData.address.country,
		});
	}

    setDisabled(disabled: boolean) {
        this.muVisible(!disabled, 'bAres');
		this.container.querySelectorAll("input").forEach(input => input.disabled = disabled);
    }
}